<template>
  <v-dialog v-model="value" width="1200" height="500" persistent>
    <v-card v-if="tag">
      <v-card-title class="headline font-weight-thin">
        <div>
          <strong data-cy="label">{{ tag.label }}</strong>
        </div>
      </v-card-title>

      <v-card-title class="mt-n5">
        <div class="subtitle-1" data-cy="releaseNoteCountMessage">{{ releaseNoteList.length }} Release Note(s)</div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="releaseNoteList"
          :items-per-page="5"
          :search="search"
          class="elevation-0"
          dense
          item-key="id"
        >
          <template v-slot:top>
            <v-row>
              <v-col sm="12" md="6">
                <v-text-field
                  clearable
                  dense
                  label="Search"
                  outlined
                  prepend-inner-icon="search"
                  single-line
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.releaseNoteId }}</td>
              <td>
                <router-link
                  :to="`/pack/${item.packId}/releaseNote/${item.releaseNoteId}/testPlan/${item.serviceAreaId}/view`"
                  data-cy="releaseNoteLink"
                  >{{ item.title }}</router-link
                >
              </td>
            </tr>
          </template></v-data-table
        >
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="close" class="mr-2" outlined>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "ID", align: "start", value: "releaseNoteId", width: "4.25rem" },
        { text: "Title", value: "title" },
      ],
      dialog: false,
      search: null,
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
  props: {
    releaseNoteList: { required: true, type: Array },
    tag: { required: true, type: Object },
    value: { required: true, type: Boolean },
  },
};
</script>
